/* @flow */

import React from 'react';
import { useTheme } from '@mui/styles';
import { MicOnIcon } from 'assets/images';
import PropTypes from 'prop-types';
import BaseIndicator from './BaseIndicator';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const AudioUnmutedIndicator = ({ tooltipPosition }) => {
  const theme = useTheme();

  return (
    <BaseIndicator
      icon={MicOnIcon}
      iconColor={theme.palette.success01}
      iconId="mic-enabled"
      iconSize={12}
      id="audioUnMuted"
      tooltipKey="videothumbnail.unmute"
      tooltipPosition={tooltipPosition}
    />
  );
};
AudioUnmutedIndicator.propTypes = {
  tooltipPosition: PropTypes.string
};
export default React.memo(withBoundary(AudioUnmutedIndicator));
